import { render, staticRenderFns } from "./starshop-description-column.vue?vue&type=template&id=2885131e"
import script from "./starshop-description-column.vue?vue&type=script&lang=js"
export * from "./starshop-description-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports